import { useState, useEffect } from 'react';

const useImportJson = <T>(packageName: string, predicate?: boolean): undefined | T => {
    const [data, setData] = useState<T | undefined>();

    useEffect(() => {
        // Lazy import of json data
        if (!predicate) {
            return;
        }
        const loadJson: Promise<any> = import(`${packageName}`);
        loadJson
            .then((module) => {
                setData(module.default as T);
            })
            .catch((e) => {
                console.error(e);
            });
    }, [packageName, predicate]);
    return data;
};

export default useImportJson;
